import { FieldHasValue, ValidateNumberField } from 'helpers/Validation';

export const FoundResultF102AftResultFormula = (formData) => {
    if (FieldHasValue(formData.F665AftSimulatedGap1 ?? formData.F124AftGaugeReading1)
        && FieldHasValue(formData.AftSimulatedGap2 ?? formData.F125AftGaugeReading2)
        && FieldHasValue(formData.AftSimulatedGap3 ?? formData.F126AftGaugeReading3)
        && FieldHasValue(formData.F45TxReading1)
        && FieldHasValue(formData.F46TxReading2)
        && FieldHasValue(formData.F47TxReading3)
        && FieldHasValue(formData.F48HmiReading1)
        && FieldHasValue(formData.F49HmiReading2)
        && FieldHasValue(formData.F50HmiReading3) && FieldHasValue(formData.F101AftTolerance)) {
        if (Math.max(ValidateNumberField(formData.F54DeviationEu1), ValidateNumberField(formData.F55DeviationEu2), ValidateNumberField(formData.F56DeviationEu3))
            <= ValidateNumberField(formData.F101AftTolerance)) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};

export const FoundResultF62SensorTrimNeedFormula = (formData) => {
    if (formData.F102AftResult) {
        if (ValidateNumberField(formData.F26InstrumentUrv) > ValidateNumberField(formData.F25InstrumentLrv)) {
            return Math.max(ValidateNumberField(formData.F54DeviationEu1),
            ValidateNumberField(formData.F55DeviationEu2), ValidateNumberField(formData.F56DeviationEu3))
                / (ValidateNumberField(formData.F26InstrumentUrv) - ValidateNumberField(formData.F25InstrumentLrv)) <= 0.01 ? 'NO' : 'YES';
        }
        return '';
    }
    return '';
};
